import React from 'react';
import Navbar from '../components/navbar';
import DatosUsuario from '../components/datosUsuario';

function PerfilUsuario () {
    return (
        <DatosUsuario />
    )
}

export default PerfilUsuario;